import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormLabel,
  InputBase,
  MenuItem,
  Select
} from '@material-ui/core'
import { Search } from 'lucide-react'
import { useEffect, useState } from 'react'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { useStyles } from './style'

const getContactLabel = option => `${option.name} - ${option.number}`

export function ContactsFilter({ onFiltered, label = 'Contato' }) {
  const classes = useStyles()
  const [options, setOptions] = useState([])
  const [selected, setSelected] = useState([])
  const [searchParam, setSearchParam] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let active = true
    setLoading(true)

    const delayDebounceFn = setTimeout(async () => {
      try {
        const { data } = await api.get('/contacts', {
          params: { searchParam, pageNumber: 1, limit: 20 }
        })
        if (active) {
          setOptions(data.contacts)
        }
      } catch (err) {
        toastError(err)
      } finally {
        if (active) {
          setLoading(false)
        }
      }
    }, 500)

    return () => {
      active = false
      clearTimeout(delayDebounceFn)
    }
  }, [searchParam])

  const selectedIds = selected.map(contact => contact.id)

  const handleChange = event => {
    const value = event.target.value
    const selectedContacts = options.filter(contact => value.includes(contact.id))
    setSelected(selectedContacts)
    onFiltered(selectedContacts)
  }

  const renderValue = () => {
    if (selected.length === 0) return 'Selecione'
    const text = selected.map(getContactLabel).join(', ')
    return (
      <span className={classes.selectedText} title={text}>
        {text}
      </span>
    )
  }

  return (
    <FormControl fullWidth className={classes.formControl}>
      <FormLabel id="contacts-filter-label">{label}</FormLabel>
      <Select
        labelId="contacts-filter-label"
        multiple
        displayEmpty
        variant="outlined"
        value={selectedIds}
        onChange={handleChange}
        renderValue={renderValue}
        MenuProps={{
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          transformOrigin: { vertical: 'top', horizontal: 'left' },
          getContentAnchorEl: null,
          classes: { paper: classes.menuPaper }
        }}
      >
        <div
          className={classes.searchBox}
          onClick={event => event.stopPropagation()}
          onKeyDown={event => event.stopPropagation()}
        >
          <Search size={16} />
          <InputBase
            className={classes.searchInput}
            placeholder="Pesquisar por nome ou número"
            value={searchParam}
            onChange={e => setSearchParam(e.target.value)}
            onClick={event => event.stopPropagation()}
            onKeyDown={event => {
              event.stopPropagation()
            }}
            autoFocus
          />
          {loading && <CircularProgress color="inherit" size={14} />}
        </div>
        {options.length === 0 && (
          <MenuItem disabled value="">
            Nenhum contato encontrado
          </MenuItem>
        )}
        {options.map(option => (
          <MenuItem key={option.id} value={option.id}>
            <Checkbox
              className={classes.checkbox}
              checked={selectedIds.includes(option.id)}
              size="small"
              color="primary"
            />
            {getContactLabel(option)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
